import React from 'react';
import { useParams } from 'react-router-dom';

const UserDetail = () => {
  const { id } = useParams();

  return <div>{id}번 사용자 상세 정보</div>;
};

export default UserDetail;